<template>
  <div class="contentBox">

    <p class="head tip" v-if="!!backShow" @click="goback()"><a>{{publicText.backTitle}}</a></p>

    <p class="head">{{contents.title}}</p>

    <div class="tip" v-if="!!contents.tipTitle || !!contents.tip">
      <div class="tipTitle">{{contents.tipTitle}}</div>
      <div class="tipText">&nbsp;&nbsp;&nbsp;&nbsp;{{contents.tip}}</div>
    </div>

    <p class="mainContent" :style="{textAlign: isAr ? 'right' : 'left'}">{{contents.text}}</p>
    <template v-for="item in contents.step">
      <p class="contentTitle" :style="{textAlign: isAr ? 'right' : 'left'}">{{item.title}}</p>
      <p class="contentTip" :style="{textAlign: isAr ? 'right' : 'left'}">{{item.tip}}</p>
      <template v-for="collect in item.collections">
        <p class="colTitle col" :style="{textAlign: isAr ? 'right' : 'left'}">{{collect.title}}</p>
        <p v-if="!!collect.text" class="colDetail col" :style="{textAlign: isAr ? 'right' : 'left'}">&nbsp;&nbsp;&nbsp;&nbsp;{{collect.text}}</p>
      </template>
    </template>
  </div>
</template>

<script>

  export default {
    name: 'blprivacy',
    data() {
      return {
        backShow: false,
        publicText: "", // 公共区域文本
        contents: "",
        isAr: false
      }
    },
    created() {
      let showBack = this.getUrlParam('showBack');
      if (showBack && showBack === 'true') {
        this.backShow = true;
      }
      let publicText = require("../../static/js/privacy");
      publicText = publicText.default;
      //判断页面参数
      var hrefStr = window.location.search || "";
      var indexBL = hrefStr.indexOf("language=");
      if(indexBL >= 0) {
        var languages = this.getUrlParam('language');
        this.publicText = publicText[languages] || publicText['en'];
      } else {
        var localLanguage = navigator.language.toLowerCase();
        if (localLanguage === 'ar') {
          this.isAr = true;
          var rootHtml = document.getElementById('rootHtml');
          rootHtml.setAttribute('style', 'direction: rtl;unicode-bidi:bidi-override;');
        }
        this.publicText = publicText[localLanguage];
        if (!this.publicText) {
          console.log("未找到的语言=", localLanguage);
          this.publicText = publicText[localLanguage]||publicText[localLanguage.split("-")[0]]||publicText['en'];
        }
      }
      // 修改标签显示title
      document.title = this.publicText.title;
      this.contents = this.publicText.contents;
    },
    methods: {
      goback() {
        window.history.back();
      },
      getUrlParam(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
        var r = window.location.search.substr(1).match(reg);  //匹配目标参数
        if (r != null) return decodeURI(r[2]); return ""; //返回参数值
      }

  }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

  @import '../../static/css/common.scss';
  @import '../../static/css/public.scss';

  // 文本
  .contentBox {
    p {
      color: black;
      text-align: left;
    }
    .isArStyle {
      color: black;
      text-align: right;
    }
    .head {
      @include font-dpr(18);
      margin-bottom: pxtorem(30);
      text-align: center;
      font-weight: bold;
    }
    .tip {
      padding: 0 pxtorem(12);
      color: gray;
      text-align: left;

      .tipTitle {
        margin-top: pxtorem(15);
        @include font-dpr(14);
        line-height: pxtorem(40);
      }

      .tipText {
        margin-top: pxtorem(5);
        @include font-dpr(12);
        line-height: pxtorem(30);
      }
    }

    .mainContent {
      margin-top: pxtorem(23);
      line-height: pxtorem(40);
      @include font-dpr(15);
    }

    .contentTitle {
      margin-top: pxtorem(20);
      //font-size: pxtorem(24);
      @include font-dpr(14);
      line-height: pxtorem(40);
    }
    .contentTip {
      margin-top: pxtorem(8);
      //font-size: pxtorem(23);
      @include font-dpr(13);
      line-height: pxtorem(30);
    }


    .col {
      margin-top: pxtorem(12);
      line-height: pxtorem(30);
    }

    .colTitle {
      //font-size: pxtorem(18);
      @include font-dpr(13);
    }

    .colDetail {
      @include font-dpr(12);
      //font-size: pxtorem(16);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Privacy.vue